import './workshop.scss';
import {useTranslation} from "react-i18next";
import {Modal} from "../../../components/User_Side/modal/Modal";
import {bookWorkshop} from "../../../api/api";
import {WHATSAPP_NUMBER} from "../../../constants/constants";
import workshopGirlsWorking from "../../../assets/images/workshop/atelier_bijoux_3.jpeg";
import workshopGirlsEnjoying from "../../../assets/images/workshop/atelier_bijoux_8.jpeg";

const Workshop = ({ props }: {
    props: {
        modal: boolean;
        setModal: (modal: boolean) => void;
        submitted: boolean;
        setSubmitted: (submitted: boolean) => void;}
}) => {
    const {t} = useTranslation()

    return (
        <div className={"Workshop"}>
            <div className={"textes-wrapper"}>
                <div className={"section"}>
                    <div className={"section-paragraph"}>
                        <div className={"photo-and-text"}>
                            <div>
                                <h3 className={"section-title"}>{t("workshop.title")}</h3>
                                <button className="btn newsletter-button" onClick={() => props.setModal(true)}>
                                    {t('workshop.form.title')}
                                </button>
                                <br/><br/>
                                <div>
                                    <p><b>{t("workshop.subtitle_transformation")}</b></p>
                                    <p>{t("workshop.summary")}</p>
                                    <p><b>{t("workshop.texts.concept")}</b> {t("workshop.texts.concept_content")}</p>
                                    <p><b>{t("workshop.texts.experience")}</b>{t("workshop.texts.experience_content")}</p>
                                    <p><b>{t("workshop.texts.result")}</b>{t("workshop.texts.result_content")}</p>
                                </div>
                                <div className={"photo-and-text"}>
                                    <img alt={"workshop girls enjoying"} src={workshopGirlsEnjoying} height={200}/>
                                    <img alt={"workshop girls working"} src={workshopGirlsWorking} height={200}/>
                                </div>
                                <br/>

                                <p><b>{t("workshop.subtitle_redesign")}</b></p>
                                <p>{t("workshop.texts.redesign")}</p>
                                <br/>
                            </div>
                        </div>
                    </div>
                </div>
                {props.modal && (
                    <Modal
                        message={t("workshop.form.title")}
                        fields={[
                            { name: 'firstName', label: `${t("workshop.form.firstName")}`},
                            { name: 'phone', label: `${t("workshop.form.phone")}`},
                            { name: 'workshop_type', label: `${t("workshop.form.workshop_type")}`, type: 'workshop_type' },
                        ]}
                        confirmLabel={t("testimony.send")}
                        cancelLabel={t("testimony.cancel")}
                        onCancel={() => props.setModal(false)}
                        submitted={props.submitted}
                        confirmationText={t("workshop.form.confirmation")}
                        onConfirm={async (data) => {
                            if (!data?.firstName || !data?.phone || !data?.workshop_type) return;
                            try {
                                const fd = new FormData();
                                fd.append('firstName', data.firstName);
                                fd.append('phone', data.phone);
                                fd.append('workshopType', data.workshop_type);
                                await bookWorkshop(fd);
                                props.setSubmitted(true);

                                const message = `Bonjour Mariposa,\nPrise de contact de la part de ${data.firstName} (${data.phone}) :\npour ${t(`workshop.${data.workshop_type}`)}`;
                                const waUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
                                window.open(waUrl, '_blank');
                                setTimeout(() => props.setSubmitted(false), 1000);
                                setTimeout(() => props.setModal(false), 1000);

                            } catch (e) { console.error(e); }
                        }}
                    />
                )}
            </div>
        </div>
    )
}
export default Workshop;
